import React, { useEffect, useState } from 'react';
import './Preparationexpedition.css';
import Graph4 from '../components/Graph4';
import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';

/* ===================================================
   ★ CONFIGURATION
   =================================================== */
const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://demo.myssa.net/api';

// ★ Taille du graphique Graph4 (proche de la version d'origine : 700 × 500)
const GRAPH_LARGEUR = '700px';
const GRAPH_HAUTEUR = '450px';

const toneHorizon = (v) => (v === 'Retard' ? 'danger' : v === 'J' ? 'warn' : 'ok');

const estNombre = (v) => v !== null && v !== undefined && v !== '' && !isNaN(Number(String(v).replace(',', '.')));

const Preparationexpedition = () => {

  useEffect(() => {
    document.title = 'MYSSA – Préparation';
  }, []);

  const [data, setData] = useState([]);
  const [pickingLog, setPickingLog] = useState([]);
  const [filteredPickingLog, setFilteredPickingLog] = useState([]);
  const [selectedCommande, setSelectedCommande] = useState(null);
  const [selectedHorizon, setSelectedHorizon] = useState(null);

  const hiddenColumns = ['ID', 'Client_id'];

  // --------------------
  // Export Excel (inchangé)
  // --------------------
  const exportToExcel = () => {
    if (!displayedPickingLog || displayedPickingLog.length === 0) return;

    const today = new Date();
    const dateStr = `${String(today.getDate()).padStart(2, '0')}/${String(today.getMonth() + 1).padStart(2, '0')}/${today.getFullYear()}`;

    const firstRow = displayedPickingLog[0];
    const numCommande = firstRow['Commande client'] || '';
    const client = firstRow['Client'] || '';

    // Colonnes source à exclure de l'affichage
    const excludedCols = [...hiddenColumns, 'Client', 'Stock', 'Rupture', 'Horizon'];

    // Colonnes finales dans l'ordre voulu
    const sourceCols = Object.keys(firstRow).filter(k => !excludedCols.includes(k));
    const finalCols = [...sourceCols, 'Qté préparée', 'Manquant'];

    const nbLignes = displayedPickingLog.length;

    const aoa = [
      [`PICKING LIST  —  Commande : ${numCommande}  -  ${client}  -  ${dateStr}`],
      [`Client : ${client}`, '', `Date : ${dateStr}`, '', `Nb lignes : ${nbLignes}`],
      [],
      finalCols.map(c => (c === 'RAL' ? 'Qté commandé' : c)),
      ...displayedPickingLog.map(row =>
        finalCols.map(c => {
          if (c === 'Qté préparée') return '';
          if (c === 'Manquant') return '';
          return row[c] ?? '';
        })
      ),
      [],
      [],
      [],
      ['Préparateur :', '', 'Nom : _______________________', '', '', 'Signature : _______________________'],
      [],
      ['Date de préparation :', '', '_______ / _______ / _______'],
    ];

    const ws = XLSX.utils.aoa_to_sheet(aoa);

    ws['!merges'] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: finalCols.length - 1 } },
    ];

    ws['!cols'] = finalCols.map(c =>
      c === 'Description' ? { wch: 36 } :
      c === 'Emplacement' ? { wch: 22 } :
      c === 'Commande client' ? { wch: 18 } :
      c === 'RAL' ? { wch: 14 } :
      c === 'Qté préparée' ? { wch: 14 } :
      c === 'Manquant' ? { wch: 13 } :
      c.toLowerCase().includes('date') ? { wch: 14 } :
      { wch: 13 }
    );

    ws['!rows'] = [
      { hpt: 28 },
      { hpt: 16 },
      { hpt: 6 },
      { hpt: 18 },
    ];

    const titleCell = ws['A1'];
    if (titleCell) {
      titleCell.s = {
        font: { bold: true, sz: 14, color: { rgb: 'FFFFFF' } },
        fill: { fgColor: { rgb: '04202D' } },
        alignment: { horizontal: 'center', vertical: 'center' },
      };
    }

    ['A2', 'C2', 'E2'].forEach(addr => {
      if (ws[addr]) {
        ws[addr].s = {
          font: { bold: true, sz: 10, color: { rgb: '04202D' } },
          fill: { fgColor: { rgb: 'E8F4FD' } },
          alignment: { horizontal: 'left', vertical: 'center' },
        };
      }
    });

    finalCols.forEach((_, ci) => {
      const addr = XLSX.utils.encode_cell({ r: 3, c: ci });
      if (ws[addr]) {
        ws[addr].s = {
          font: { bold: true, sz: 10, color: { rgb: 'FFFFFF' } },
          fill: { fgColor: { rgb: '1E3A5F' } },
          alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
          border: { bottom: { style: 'medium', color: { rgb: '38BDF8' } } },
        };
      }
    });

    const qtePrepIndex = finalCols.indexOf('Qté préparée');
    const manquantIndex = finalCols.indexOf('Manquant');

    displayedPickingLog.forEach((row, ri) => {
      const excelRow = 4 + ri;
      const isEven = ri % 2 === 0;
      const bgFill = isEven ? { fgColor: { rgb: 'FFFFFF' } } : { fgColor: { rgb: 'F5F8FC' } };

      finalCols.forEach((col, ci) => {
        const addr = XLSX.utils.encode_cell({ r: excelRow, c: ci });
        if (!ws[addr]) ws[addr] = { t: 's', v: '' };

        let fill = bgFill;
        const font = { sz: 10 };
        let border = {
          bottom: { style: 'thin', color: { rgb: 'E2E8F0' } },
          right: { style: 'thin', color: { rgb: 'E2E8F0' } },
        };

        if (ci === qtePrepIndex || ci === manquantIndex) {
          fill = { fgColor: { rgb: 'FFFBEB' } };
          border = {
            ...border,
            left: { style: 'thin', color: { rgb: 'FCD34D' } },
            right: { style: 'thin', color: { rgb: 'FCD34D' } },
          };
        }

        ws[addr].s = {
          fill,
          font,
          border,
          alignment: {
            horizontal: 'center',
            vertical: 'center',
            wrapText: col === 'Emplacement',
          },
        };
      });
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Picking List');

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    const filename = selectedCommande
      ? `Picking_List_${numCommande}_${dateStr.replace(/\//g, '-')}.xlsx`
      : `Picking_List_${dateStr.replace(/\//g, '-')}.xlsx`;
    saveAs(blob, filename);
  };

  // --------------------
  // Chargement données (inchangé)
  // --------------------
  useEffect(() => {
    fetch(`${API}/plan_expedition_cmde_client`)
      .then(response => response.json())
      .then(data => {
        const filteredData = data.map(item => ({
          Horizon: item.Horizon,
          'Nbre de commande': item['Nbre de commande'],
          'Nbre de ligne': item['Nbre de ligne'],
        }));
        setData(filteredData);
      })
      .catch(error => console.error('Erreur plan_expedition_cmde_client:', error));
  }, []);

  useEffect(() => {
    fetch(`${API}/picking_log`)
      .then(response => response.json())
      .then(data => {
        const filteredData = data.filter(
          item => item && item['Date de livraison prevue'] && item['Horizon'] !== 'J++'
        );
        const formattedData = filteredData.map(item => {
          let formattedDate = '';
          if (item['Date de livraison prevue']) {
            const d = new Date(item['Date de livraison prevue']);
            if (!isNaN(d)) formattedDate = d.toLocaleDateString('fr-FR');
          }
          return { ...item, 'Date de livraison prevue': formattedDate };
        });
        setPickingLog(formattedData);
        setFilteredPickingLog([]);
        setSelectedCommande(null);
      })
      .catch(error => console.error('Erreur picking_log:', error));
  }, []);

  // --------------------
  // Handlers (inchangés)
  // --------------------
  const handleHorizonClick = (horizonValue) => {
    const filteredData = pickingLog.filter(item => item.Horizon === horizonValue);
    const uniqueCommandes = [...new Set(filteredData.map(item => item['Commande client']))];
    setFilteredPickingLog(uniqueCommandes);
    setSelectedCommande(null);
    setSelectedHorizon(horizonValue);
  };

  const handleCommandeClick = (commande) => {
    setSelectedCommande(commande);
  };

  const displayedPickingLog = selectedCommande
    ? pickingLog.filter(item =>
        item['Commande client'] === selectedCommande &&
        item.Horizon === selectedHorizon
      )
    : pickingLog;

  const colonnesPicking = displayedPickingLog[0]
    ? Object.keys(displayedPickingLog[0]).filter(key => !hiddenColumns.includes(key))
    : [];

  const Pill = ({ tone, children }) => <span className={`px-badge px-badge-${tone}`}>{children}</span>;

  // --------------------
  // Rendu d'une cellule du picking log
  // --------------------
  const renderCellule = (item, key) => {
    const value = item[key];
    if (key === 'Horizon') return <td key={key}><Pill tone={toneHorizon(value)}>{value}</Pill></td>;
    if (key === 'Rupture') {
      return Number(value) !== 0
        ? <td key={key} className="num"><Pill tone="danger">{value}</Pill></td>
        : <td key={key} className="num px-mono px-muted">{value}</td>;
    }
    if (key === 'Emplacement') {
      return value === 'pas de stock'
        ? <td key={key}><Pill tone="danger">{value}</Pill></td>
        : <td key={key} className="px-mono px-pre">{value}</td>;
    }
    if (key === 'Item') return <td key={key} className="px-mono px-strong">{value}</td>;
    if (['Commande client', 'Date de livraison prevue'].includes(key)) return <td key={key} className="px-mono">{value}</td>;
    if (key === 'Description') return <td key={key} className="px-wrap">{value}</td>;
    if (estNombre(value)) return <td key={key} className="num px-mono">{value}</td>;
    return <td key={key}>{value}</td>;
  };

  // ===================================================
  // RENDU
  // ===================================================
  return (
    <div className="px-page">
      {/* ★ En-têtes et données centrés dans les tableaux Horizon et Picking log (prioritaire sur
            Preparationexpedition.css, y compris la classe "num" qui aligne les nombres à droite) */}
      <style>{`
        .px-table th, .px-table th.num,
        .px-table td, .px-table td.num { text-align: center !important; vertical-align: middle; }
        .px-table .px-row-btn { text-align: center; justify-content: center; }
      `}</style>
      <div className="px-container">

        {/* ── Header ── */}
        <div className="px-header">
          <div className="px-title-row">
            <div className="px-accent" />
            <h1 className="px-title">Préparation</h1>
            <span className="px-chip-dept">LOG</span>
          </div>
       
        </div>

        {/* ── Ligne du haut : graphique + horizons + commandes ── */}
        <div className="px-top">

          <div className="px-card px-graph-card">
            <Graph4 width={GRAPH_LARGEUR} height={GRAPH_HAUTEUR} />
          </div>

          {/* Tableau 1 — Horizon */}
          <div className="px-card px-side-card px-horizon-card">
            <div className="px-card-head">
              <span className="px-step">1</span>
              <div className="px-card-title">Horizon</div>
            </div>
            <div className="px-side-scroll">
              <table className="px-table">
                <thead>
                  <tr>
                    <th>Horizon</th>
                    <th className="num">Commandes</th>
                    <th className="num">Lignes</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => {
                    const actif = selectedHorizon === item.Horizon;
                    return (
                      <tr
                        key={index}
                        className={`px-row-click ${actif ? 'active' : ''}`}
                        onClick={() => handleHorizonClick(item.Horizon)}
                      >
                        <td>
                          <button
                            type="button"
                            className="px-row-btn"
                            aria-pressed={actif}
                            onClick={(e) => { e.stopPropagation(); handleHorizonClick(item.Horizon); }}
                          >
                            <Pill tone={toneHorizon(item.Horizon)}>{item.Horizon}</Pill>
                          </button>
                        </td>
                        <td className="num px-mono">{item['Nbre de commande']}</td>
                        <td className="num px-mono">{item['Nbre de ligne']}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          {/* Tableau 2 — Commandes restantes à préparer */}
          <div className="px-card px-side-card px-cmd-card">
            <div className="px-card-head">
              <span className="px-step">2</span>
              <div className="px-card-title">Cdes restantes</div>
              {selectedHorizon && <Pill tone={toneHorizon(selectedHorizon)}>{selectedHorizon}</Pill>}
              {filteredPickingLog.length > 0 && <span className="px-count">{filteredPickingLog.length}</span>}
            </div>

            <div className="px-side-scroll">
              {filteredPickingLog.length === 0 ? (
                <div className="px-empty">Clique sur un horizon pour lister les commandes à préparer.</div>
              ) : (
                <div className="px-cmd-list">
                  {filteredPickingLog.map((commande, index) => {
                    const lignesCommande = pickingLog.filter(
                      item => item['Commande client'] === commande && item.Horizon === selectedHorizon
                    );
                    const totalRupture = lignesCommande.reduce(
                      (sum, item) => sum + Number(item.Rupture || 0), 0
                    );
                    const ok = totalRupture === 0;
                    const actif = selectedCommande === commande;
                    return (
                      <button
                        key={index}
                        type="button"
                        aria-pressed={actif}
                        className={`px-cmd ${ok ? 'ok' : 'ko'} ${actif ? 'active' : ''}`}
                        onClick={() => handleCommandeClick(commande)}
                        title={ok ? 'Complète : aucune rupture' : `${totalRupture} en rupture`}
                      >
                        <span className="px-cmd-num">{commande}</span>
                        <span className="px-cmd-meta">
                          {lignesCommande.length} l. · {ok ? 'complète' : `rupture ${totalRupture}`}
                        </span>
                      </button>
                    );
                  })}
                </div>
              )}
            </div>

            <div className="px-card-foot">
              <span className="px-step">3</span>
              <button
                type="button"
                className="px-btn px-btn-primary"
                onClick={exportToExcel}
                disabled={displayedPickingLog.length === 0}
              >
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M12 3v12" /><path d="M7 10l5 5 5-5" /><path d="M5 21h14" />
                </svg>
                Exporter la picking list {selectedCommande ? selectedCommande : ''}
              </button>
            </div>
          </div>
        </div>

        {/* ── Tableau 3 — Picking log ── */}
        <div className="px-card px-table-card">
          <div className="px-card-head">
            <div className="px-card-title">
              {selectedCommande ? `Picking log — commande ${selectedCommande}` : 'Picking log complet'}
            </div>
            <span className="px-count">{displayedPickingLog.length} ligne{displayedPickingLog.length > 1 ? 's' : ''}</span>
            {selectedCommande && (
              <button type="button" className="px-btn px-btn-ghost px-push" onClick={() => setSelectedCommande(null)}>
                Tout afficher
              </button>
            )}
          </div>
          <div className="px-table-scroll">
            {displayedPickingLog.length === 0 ? (
              <div className="px-empty">Aucune ligne à préparer.</div>
            ) : (
              <table className="px-table">
                <thead>
                  <tr>
                    {colonnesPicking.map(key => (
                      <th key={key} className={estNombre(displayedPickingLog[0][key]) ? 'num' : ''}>{key}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {displayedPickingLog.map((item, rowIndex) => (
                    <tr key={rowIndex} className={`px-row-${toneHorizon(item.Horizon)}`}>
                      {colonnesPicking.map(key => renderCellule(item, key))}
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>

      </div>
    </div>
  );
};

export default Preparationexpedition;